import { create } from "zustand";

type EventAccessPaywallModalState = {
  forcedOpen: boolean;
  requestOpen: () => void;
  dismissForced: () => void;
};

export const useEventAccessPaywallModalStore = create<EventAccessPaywallModalState>((set) => ({
  forcedOpen: false,
  requestOpen: () => set({ forcedOpen: true }),
  dismissForced: () => set({ forcedOpen: false }),
}));
